<script setup lang="ts">
import { useOrderStore } from '@/stores/useOrderStore'
import { ORDER_STATUS } from '@/constants/orderStatus'

defineProps(['params'])
const orderStore = useOrderStore()
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-fit">
      <span
        :class="{
          'badge bg-neutral-100': params.data.status === ORDER_STATUS.DRAFT,
          'badge bg-blue-100': params.data.status === ORDER_STATUS.WAITING,
          'badge bg-emerald-100': params.data.status === ORDER_STATUS.VALIDATED,
          'badge bg-blue-50': params.data.status === ORDER_STATUS.IN_PROGRESS,
          'badge bg-orange-100': params.data.status === ORDER_STATUS.BLOCKED_BUSINESS || params.data.status === ORDER_STATUS.BLOCKED_OPERATOR,
          'badge bg-red-100': params.data.status === ORDER_STATUS.CANCELED,
          'badge bg-[#DA70D6] text-white': params.data.status === ORDER_STATUS.SENT_TO_BU_MANAGER,
        }"
      >
        {{ orderStore.getStatusLabel(params.data.status) }}
      </span>
    </div>
  </div>
</template>

<style scoped></style>
